/* us */

/* int */
angular.module('olivioConfiguratorApp').constant('env', {
  dataVariant: 'de',
  absoluteUrlPrefix: '/configurator/olivio/',
  modelStorageUrl: '/configurator/olivio/php/scripts/model.php',
  configurationStorageUrl: '/configurator/olivio/php/scripts/configurationStorage.php',
  pdfGeneratorUrl: '/configurator/olivio/php/scripts/pdf.php?token=:token&lang=:lang',
  dxfGeneratorUrl: '/configurator/olivio/php/scripts/dxf.php?fileNameSuffix=:fileNameSuffix',
	dxfGeneratorZipUrl: '/configurator/olivio/php/scripts/dxfzip.php',
	ldtFilesDownloadUrl: 'https://products.selux.com/products/ldtFiles/',
  mailUrl: '/configurator/olivio/php/scripts/mail.php?token=:token',
  authUrl: '/configurator/user-management/auth.php',
  permalinkBaseUrl: 'https://www.selux.com/configurator/olivio/#!/'
});
